import { render, staticRenderFns } from "./VerticalSlider.vue?vue&type=template&id=0ec424e4&scoped=true&"
import script from "./VerticalSlider.vue?vue&type=script&lang=js&"
export * from "./VerticalSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec424e4",
  null
  
)

export default component.exports